export default __webpack_public_path__ + "static/media/table.307557ae.jpeg";